module.exports = __webpack_public_path__ + "media/images/products/category/sm/11-f18028f39536fe56ceef13d291aa033f.jpg";